export default {

    //empty-states
    no_coupons: 'Oops! Sem cupões',
    text_coupon: 'Comece por criar um novo cupão de desconto.',
    new_coupon: 'Novo cupão',

}